import React, { useState, useRef, useEffect } from "react";
import "./ContactUsComponent.css";
import * as faceapi from "face-api.js";

import axios from "axios";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../../Pages/utils/page";
import { toast } from "react-toastify";

const ContactUsComponent = ({ checkValue, setCheckValue }) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    PhoneNo: "",
    Address: "",
    errorImage: "",
    Description: "",
  });
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prevData) => ({
          ...prevData,
          errorImage: reader.result,
        }));
      };
      reader.readAsDataURL(file); // Converts the file to base64
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const validateAddress = () => {
    const phonePattern = /^\d{10}$/;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!formData?.Name || formData?.Name?.trim() === "") {
      toast.error("Please enter Name");
      return false;
    }
    if (!formData?.Email || !formData?.Email?.match(emailPattern)) {
      toast.error("Please enter valid Email");
      return false;
    }
    if (!formData.PhoneNo || !formData.PhoneNo.match(phonePattern)) {
      toast.error("Please enter a valid Phone number");
      return false;
    }

    if (!formData?.Address || formData?.Address?.trim() === "") {
      toast.error("Please enter Address");
      return false;
    }
    if (checkValue && !formData?.errorImage) {
      toast.error("Please upload image");
      return false;
    }
    if (!formData?.Description || formData?.Description?.trim() === "") {
      toast.error("Please enter Description");
      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    if (!validateAddress()) return;
    const data = {
      username: formData?.Name,
      email: formData?.Email,
      phoneNumber: formData?.PhoneNo,
      address: formData?.Address,
      comment: formData?.Description,
      ErrorImage: formData?.errorImage,
      IsErrorImageGiven: checkValue,
      userId: null,
      userQueryDto: null,
      // userId:
    };

    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/Customer/ContactUs`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setFormData({
          ...formData,
          Name: "",
          Email: "",
          PhoneNo: "",
          Address: "",
          Description: "",
          errorImage: "",
        });
        document.getElementById("image-upload-contact").value = "";
      })
      .catch((error) => {});
  };

  return (
    <>
      <div className="banner_section" style={{ flex: "1" }}>
        <div>
          <div className="contact-top-section">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-12 col-sm-12 mb_commn_pd_0">
                  <h3>Contact Us</h3>
                  <div>
                    <p>
                      Connect with Shop Saverz: Reach Out for Assistance Today
                    </p>
                    <p className="mb-0">
                      <strong>EMAIL: </strong>
                      <a href="mailto:contact@shopsaverz.com">
                        contact@shopsaverz.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <form>
            <div className="about_custom_form">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 mr-auto ml-auto">
                    <div className="form about_form">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Full Name</label>
                            <input
                              className="form-control"
                              type="text"
                              name="Name"
                              placeholder="Name"
                              value={formData.Name}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Email</label>
                            <input
                              className="form-control"
                              type="email"
                              name="Email"
                              placeholder="user@example.com"
                              value={formData.Email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Phone No</label>
                            <input
                              className="form-control"
                              type="tel"
                              name="PhoneNo"
                              maxLength="10"
                              pattern="\d{10}"
                              placeholder="Your Phone Number"
                              value={formData.PhoneNo}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Address</label>
                            <input
                              className="form-control"
                              type="text"
                              name="Address"
                              placeholder="Your Address"
                              value={formData.Address}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-check-inline checkbox_banner">
                            <input
                              type="checkbox"
                              id="image-upload"
                              onChange={(e) =>
                                setCheckValue(e?.target?.checked)
                              }
                            />
                            <label htmlFor="banner2">
                              Please upload the snapshot of the error, if you
                              find any.
                            </label>
                          </div>
                        </div>
                        {checkValue ? (
                          <>
                            <form
                              id="imageForms"
                              className="col-lg-12 col-12 mb_commn_pd_0"
                            >
                              <input
                                className="form-control custom-file-input"
                                accept="image/png, image/jpeg, image/gif"
                                id="inputFile"
                                type="file"
                                onChange={handleImageUpload}
                              />
                            </form>
                            <img src={formData?.errorImage} alt="" />
                          </>
                        ) : null}

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">
                              Description
                            </label>
                            <textarea
                              id="w3review"
                              name="Description"
                              rows="4"
                              className="form-control"
                              value={formData.Description}
                              onChange={handleChange}
                            ></textarea>
                          </div>
                        </div>

                        <div className="col-lg-12 mt-3">
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactUsComponent;
